import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LabelButton from "@/components/LabelButton.vue";
import { supabase } from "@/helpers/supabase";


export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutLink',
  setup(__props) {

async function logout() {
  await supabase.auth.signOut();
  location.reload();
  window._paq.push(["trackEvent", "Logout"]);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LabelButton, {
    label: "Mit einem anderen Konto anmelden",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (logout()))
  }))
}
}

})